import React, { useState } from "react";
import "../Styles/nav-bar.css";
import { IMAGES } from "../utils/images";
import { Link, useNavigate } from "react-router-dom";
import { NavItem_Course, NavItem_Training } from "../utils/navBarConfig";
import NavbarCourseCard from "./NavbarCourseCard";
import RequestCallback from "../components/RequestCallback";
import { OVERALL_COURSES } from "../utils/constants";
import NavigationService from "../services/navigationService";

const NavBar = () => {
  //states
  const navigate = useNavigate();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [courseState, setCourseState] = useState(0);
  const [showRequestCallback, setShowRequestCallback] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [filtered_list, setFiltered_list] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [showmobileDropdown,setShowMobileDropdown]=useState(false)
  const [showcoursesDropDown,setcoursesDropDown]=useState(false)
  const [showtrainingsDropDown,settrainigsDropDown]=useState(false)



  //functions
  const handleMouseEnter = (index) => {
    setActiveDropdown(index);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const handleItemClick = (courseId, pageLink) => {
    // Close dropdowns
    setActiveDropdown(null);
    setShowMobileDropdown(false);
    
    // If courseId and pageLink are provided, use the navigation service
    if (courseId && pageLink) {
      NavigationService.navigateToCourse(courseId, pageLink, navigate);
    }
  };
  
  const handleTrainingClick = (trainingType, pageLink) => {
    // Close dropdowns
    setActiveDropdown(null);
    setShowMobileDropdown(false);
    
    // Use the navigation service
    NavigationService.navigateToTraining(trainingType, pageLink, navigate);
  };
  
  const handleContactClick = () => {
    // Close dropdowns
    setActiveDropdown(null);
    setShowMobileDropdown(false);
    
    // Use the navigation service
    NavigationService.navigateToContact('/Contact', navigate);
  };

  const handleBlur = () => {
    setTimeout(() => {
      setShowSearchResults(false);
    }, 300);
  };

  const nullText = () => {
    setSearchText("");
    setFiltered_list(null);
  };
  const handleChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    if (value === "") {
      setFiltered_list(null);
    } else {
      setFiltered_list(() =>
        OVERALL_COURSES.filter((item) =>
          item.title.toLowerCase().includes(value)
        )
      );
    }
  };
  //debouncing

  return (
    <nav className="navbar">
      <div className="nav-left">
        <div className="navbar-logo">
          <div onClick={() => {
            setShowMobileDropdown(false);
            navigate('/');
          }}>
            <img src={IMAGES.EDUTECH_LOGO} alt="Logo" className="logo-image" />
          </div>
        </div>
        <div className="nav-left-icons">
        <img src={IMAGES.SEARCH_ICON} className="search-icon-mobile" />
        <button onClick={()=>setShowMobileDropdown(!showmobileDropdown)}  className="menu-icon" ><img src={IMAGES.MENU_ICON}/></button>
        
        </div>
      </div>
      <div className={showmobileDropdown ? "nav-center-active":"nav-center"}>
        <div className="navbar-items">
          {NavItem_Course.map((item, index) => (
            <div
              key={index}
              className="navbar-item"
              onMouseEnter={() => {handleMouseEnter(index) ; console.log(activeDropdown,index)}}
              onMouseLeave={handleMouseLeave}
            >
              <button className="nav-button" onClick={()=>{setcoursesDropDown(!showcoursesDropDown)}}>
                {item.title}
                <img
                  src={IMAGES.CHEVRON_DOWN}
                  alt="Chevron"
                  className="chevron-image"
                />
              </button>
              {(activeDropdown === index || showcoursesDropDown) && (
                <div className={(showcoursesDropDown && window.innerWidth<1050)? "nav-dropdown-course-active":"nav-dropdown-course-home"}>
                  <div className="nav-dropdown-container-course-home">
                    <div className="dropdown-course-home">
                      <h1 className="dropdown-heading-course">{item.title}</h1>
                      {item.data.map((item, index) => (
                        <button
                          className={
                            index === courseState
                              ? "course-container-active"
                              : "course-container"
                          }
                          key={index}
                          onClick={() => setCourseState(index)}
                        >
                          <img
                            src={item.icon}
                            className="course-container-img"
                          />
                          <div className="course-container-name">
                            {" "}
                            {item.name}
                          </div>
                        </button>
                      ))}
                    </div>
                    <div className="overall-courses-container-home">
                      {item.data[courseState].courses.map((item, index) => (
                        <div
                          className="link-course"
                          onClick={() => handleItemClick(item.heading, item.link)}
                          key={index}
                        >
                          <NavbarCourseCard {...item} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="search">
          <div className="nav-search">
            <img src={IMAGES.SEARCH_ICON} />
            <input
              type="text"
              value={searchText}
              placeholder="Search for Courses"
              onFocus={() => {
                setShowSearchResults(true);
              }}
              onBlur={handleBlur}
              onChange={(e) => handleChange(e)}
            />
          </div>
          {showSearchResults && (
            <div className="search-results">
              {filtered_list !== null ? (
                filtered_list.length > 0 ? (
                  filtered_list.map((item) => {
                    return (
                      <div
                        className="link"
                        key={item.title}
                        onClick={() => {
                          nullText();
                          handleItemClick(item.title, item.link);
                        }}
                      >
                        <div className="single-search-result">{item.title}</div>
                      </div>
                    );
                  })
                ) : (
                  <div className="no-search-result">No results Found</div>
                )
              ) : (
                <div className="start-search-result">
                  Start typing to Search Courses...
                </div>
              )}
            </div>
          )}
        </div>
        <div className="navbar-items" >
          {NavItem_Training.map((item, index) => (
            <div
              key={index}
              className="navbar-item"
              
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <button className="nav-button" onClick={()=>{settrainigsDropDown(!showtrainingsDropDown);console.log(showtrainingsDropDown)}}>
                {item.title}
                <img
                  src={IMAGES.CHEVRON_DOWN}
                  alt="Chevron"
                  className="chevron-image"
                />
              </button>
              {(activeDropdown === index || showtrainingsDropDown) && (
                <div id={showtrainingsDropDown? "nav-dropdown-active" :"nav-dropdown" }>
                  <div id="nav-dropdown-container">
                    {/* <h1 id="dropdown-heading">{item.title}</h1> */}
                    <div className="dropdown">
                      {item.links.map((link, idx) => (
                        <div
                          key={idx}
                          className="dropdown-item"
                          onClick={() => handleTrainingClick(link.label, link.to)}
                        >
                          {link.label}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="navbar-item">
          <div className="link" onClick={() => {
            setShowMobileDropdown(false);
            navigate('/AboutUs');
          }}>
            <button className="nav-button">About Us</button>
          </div>
        </div>
        <div className="navbar-item">
          <div className="link" onClick={() => {
            handleContactClick();
          }}>
            <button className="nav-button">Contact</button>
          </div>
        </div>
        <div className="navbar-item">
          <button
            className="navbtn-callback"
            onClick={() => setShowRequestCallback(true)}
          >
            Request a Callback
          </button>
          {showRequestCallback && (
            <RequestCallback onClose={setShowRequestCallback} />
          )}
        </div>

        {sessionStorage.getItem("authenticated") ? (
          <div className="sign-in">
            <Link to="/dashboard"onClick={()=>setShowMobileDropdown(false)} >
              <button className="signin-button">Go to Dashboard</button>
            </Link>
          </div>
        ) : (
          <div className="sign-in">
            <Link to="/signin" onClick={()=>setShowMobileDropdown(false)}>
              <button className="signin-button">Sign in</button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
